import React from 'react';
import { TruncatedText } from '../../Text/TruncatedText';
import { AccordionButtonVariant, StyledAccordionButton } from './AccordionButton.styles';
import { Box } from '../../Box/Box';

interface AccordionButtonProps {
  id: string;
  panelId: string;
  isActive: boolean;
  onClick(): void;
  extra?: React.ReactNode;
  children?: string;
  content?: React.ReactNode;
  variant?: AccordionButtonVariant;
}

export const AccordionButton = ({
  id,
  panelId,
  isActive,
  extra,
  onClick,
  children,
  content,
  variant = 'default',
  ...rest
}: AccordionButtonProps) => {
  return (
    <StyledAccordionButton
      id={id}
      role="button"
      tabIndex={0}
      isActive={isActive}
      variant={variant}
      onClick={onClick}
      onKeyDown={evt => {
        if (evt.key === 'Enter') {
          onClick();
        } else if (evt.key === ' ') {
          // Prevent page scrolling down
          evt.preventDefault();

          onClick();
        }
      }}
      aria-expanded={isActive}
      aria-controls={panelId}
      aria-label={children}
      {...rest}
    >
      {content || (
        <>
          <Box flex={1}>
            <TruncatedText textAlign="left" fontWeight={500} fontSize="h6" color="inherit">
              {children}
            </TruncatedText>
          </Box>

          {extra && (
            <Box ml="12" flexShrink={0}>
              {extra}
            </Box>
          )}
        </>
      )}
    </StyledAccordionButton>
  );
};
